import { IQuoteHandler } from "./interfaces/IQuoteHandler";
import { RentalPremierQuoteHandler } from "./RentalPremierQuoteHandler";
import { RentalQuoteHandler } from "./RentalQuoteHandler";
import { ShortTermQuoteHandler } from "./ShortTermQuoteHandler";
import { QuoteType } from "./types/QuoteType";

export class QuoteHandlerFactory {
  static getQuoteInstance(quoteType: QuoteType): IQuoteHandler {
    switch (quoteType) {
      case "Rental":
        return new RentalQuoteHandler();
      case "Premier":
        return new RentalPremierQuoteHandler();
      default:
        return new ShortTermQuoteHandler();
    }
  }
}
